module.exports = __webpack_public_path__ + "static/media/testnet.02ac5932.svg";